const config = {
  serverConfig: {}
};

export default config;
